import React, { useRef, useEffect } from 'react';
import cx from 'classnames';
import { useLocation } from 'react-router-dom';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize.js';
import { AsideMenu } from './components/AsideMenu/index.js';
import { AsideMenuMobile } from './components/AsideMenuMobile/index.js';
import { BottomMenuMobile } from './components/BottomMenuMobile/index.js';
import { Header } from './components/Header/index.js';
import './components/Logo/index.js';
import './components/ToolbarWrapper/index.js';
import './components/SearchWrapper/index.js';
import './components/HeaderCenterWrapper/index.js';
import '../Context/index.js';
import { useCustomScrollbar } from './utils/useCustomScrollbar.js';
import styles from './index.module.scss.js';
import { useLayoutContext } from '../Context/utils/useLayoutContext.js';

const View = ({
  headerRight,
  headerRightMdMax,
  headerCenter,
  onLogoClick,
  onSearch = () => {
  },
  socials = [],
  tabs,
  bottomMenu,
  rightMenu,
  logo,
  tabsVersion = "v1",
  children,
  isAuthUser,
  propsLogo,
  routeToHome = "/"
}) => {
  const {
    isReady,
    isRightMenuReadyToHide,
    isRightMenuOpen,
    isAsideMenuOpen,
    setContentWidth
  } = useLayoutContext();
  const ref = useRef(null);
  const location = useLocation();
  const { windowSize } = useWindowSize();
  useCustomScrollbar();
  useEffect(() => {
    const resize = () => {
      setContentWidth(ref?.current?.offsetWidth || 0);
      if (window.innerWidth < 768) {
        setContentWidth(window.innerWidth);
        return;
      }
      setTimeout(() => {
        setContentWidth(ref?.current?.offsetWidth || 0);
      }, 800);
    };
    resize();
    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [ref]);
  useEffect(() => {
    setTimeout(() => {
      if (ref?.current) {
        setContentWidth(ref.current.offsetWidth || 0);
      }
    }, 800);
  }, [isAsideMenuOpen, isRightMenuOpen]);
  useEffect(() => {
    if (window.document.body.scrollHeight <= window?.innerHeight) {
      setTimeout(() => {
        document?.querySelectorAll("[data-aos]").forEach((el) => {
          el?.classList.add("aos-animate");
        });
      }, 100);
    }
  }, [location]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.box, {
        [styles.open]: isReady,
        [styles["left-open"]]: isAsideMenuOpen && !isRightMenuOpen,
        [styles["right-open"]]: isRightMenuOpen && !isAsideMenuOpen,
        [styles["both-open"]]: isRightMenuOpen && isAsideMenuOpen,
        "both-menu-open": isRightMenuOpen && isAsideMenuOpen,
        "only-left-menu-open": isAsideMenuOpen && !isRightMenuOpen,
        "only-right-menu-open": isRightMenuOpen && !isAsideMenuOpen,
        "no-sidebar-open": !isRightMenuOpen && !isAsideMenuOpen
      })
    },
    /* @__PURE__ */ React.createElement(
      Header,
      {
        className: styles.header,
        right: headerRight,
        rightMdMax: headerRightMdMax,
        center: headerCenter,
        routeToHome,
        isAuthUser
      }
    ),
    bottomMenu && /* @__PURE__ */ React.createElement(
      BottomMenuMobile,
      {
        className: styles["bottom-menu"],
        buttons: bottomMenu
      }
    ),
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles.layout,
        "data-left-sidebar-open": isAsideMenuOpen,
        "data-right-sidebar-open": isRightMenuOpen
      },
      windowSize.width > 1024 && /* @__PURE__ */ React.createElement(
        AsideMenu,
        {
          className: styles["left-aside"],
          onLogoClick,
          onSearch,
          socials,
          tabs,
          logo,
          propsLogo,
          tabsVersion
        }
      ),
      /* @__PURE__ */ React.createElement("div", { className: styles["main-container"], ref }, children),
      /* @__PURE__ */ React.createElement("div", { className: styles["right-aside"] }, isRightMenuOpen || !isRightMenuReadyToHide || !isRightMenuOpen && isRightMenuReadyToHide ? rightMenu : null)
    ),
    windowSize.width <= 1024 && /* @__PURE__ */ React.createElement(
      AsideMenuMobile,
      {
        className: styles["aside-mobile"],
        onLogoClick,
        onSearch,
        navBack: false,
        socials,
        tabs,
        logo
      }
    )
  );
};
View.displayName = "Layout.View";

export { View };
//# sourceMappingURL=index.js.map
